var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UIController from './ui';
const App = new class RecipeApp {
    constructor() {
        this.state = {
            route: 'list',
            background: 0
        };
    }
    router(route) {
        const displays = [...document.querySelectorAll(`[data-route]`)];
        this.state.route = route;
        if (route != 'recipe')
            document.querySelector('[data-route="recipe"]').innerHTML = ``;
        displays.forEach((display) => {
            display.dataset.route == route
                ? display.style.display = 'block'
                : display.style.display = 'none';
        });
    }
    getState() {
        return Object.assign({}, this.state);
    }
    onload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield UIController.renderCategoryItems();
            yield UIController.renderRecipeCards();
            const preloader = document.querySelector('.preloader');
            preloader.style.opacity = '0';
            setTimeout(() => {
                preloader.remove();
                document.body.style.overflowY = 'auto';
            }, 500);
        });
    }
    onchangeBackground() {
        this.state.background++;
        if (this.state.background >= 10)
            this.state.background = 0;
    }
};
window.onload = App.onload;
export default App;
